/**************************************************
 * Nombre:       Tarjeta_Pais_Seleccionado
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import {Delete} from '@mui/icons-material'

const Tarjeta_Pais_Seleccionado = ({item, quitar}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderBottom: 1, py: 0}}
        >


            <Grid container size={10} sx={{justifyContent: 'flex-start'}}>
                <Typography>{item}</Typography>
            </Grid>

            <Grid container size={2} sx={{justifyContent: 'flex-end'}}>
                <IconButton onClick={() => quitar(item)}>
                    <Delete/>
                </IconButton>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Pais_Seleccionado